function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstrumentTracking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "instrument_tracking") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3697",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fillable-area",
    "data-name": "Path 46353",
    d: "M11.835 14.049a2.214 2.214 0 1 0-2.214-2.214 2.214 2.214 0 0 0 2.214 2.214z",
    transform: "translate(.166 .166)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fillable-area",
    "data-name": "Path 46354",
    d: "M19.948 17.808a.707.707 0 0 1-.419-.14.7.7 0 0 1-.14-.977 8.6 8.6 0 0 0 0-10.325.7.7 0 0 1 1.116-.837 10 10 0 0 1 0 12 .687.687 0 0 1-.557.279z",
    transform: "translate(-.506 .471)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fillable-area",
    "data-name": "Path 46355",
    d: "M3.808 17.808a.687.687 0 0 1-.558-.279 10 10 0 0 1 0-12 .7.7 0 1 1 1.116.837 8.6 8.6 0 0 0 0 10.325.7.7 0 0 1-.14.977.687.687 0 0 1-.418.14z",
    style: {
      fill: "#fff"
    },
    transform: "translate(.75 .471)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fillable-area",
    "data-name": "Path 46356",
    d: "M16.749 15.742a.707.707 0 0 1-.419-.14.7.7 0 0 1-.14-.977 4.884 4.884 0 0 0 0-5.86.7.7 0 0 1 1.116-.837 6.279 6.279 0 0 1 0 7.535.687.687 0 0 1-.557.279z",
    transform: "translate(-.283 .304)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fillable-area",
    "data-name": "Path 46357",
    d: "M7.064 15.742a.687.687 0 0 1-.558-.279 6.279 6.279 0 0 1 0-7.535.7.7 0 0 1 1.116.837 4.884 4.884 0 0 0 0 5.86.7.7 0 0 1-.14.977.687.687 0 0 1-.418.14z",
    transform: "translate(.471 .304)",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstrumentTracking);
export default __webpack_public_path__ + "static/media/instrument_tracking.89d505f8996ca985e11422861f2d9733.svg";
export { ForwardRef as ReactComponent };